import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Form10th from './pages/Form10th';
import FormITI from './pages/FormITI';
import FormDiploma from './pages/FormDiploma';
import Success from './pages/Success';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ResumeGen from './pages/ResumeGen';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<ResumeGen />} />
        <Route path="/apply" element={<Navigate to="/form/10th" />} />
        <Route path="/apply?category=10th" element={<Navigate to="/form/10th" />} />
        <Route path="/form/10th" element={<Form10th />} />
        <Route path="/form/iti" element={<FormITI />} />
        <Route path="/form/diploma" element={<FormDiploma />} />
        <Route path="/success" element={<Success />} />
        <Route path="/jf-secure-2024" element={<AdminLogin />} />
        <Route path="/jf-secure-2024/dashboard" element={<AdminDashboard />} />
      </Routes>
      <Footer />
      <ChatBot />
    </Router>
  );
}

export default App;